 import { Component, Input, OnInit } from '@angular/core';
  import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  // importing definitions
  import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
  import { AuthService } from 'src/app/services/auth.service';
  import { ActivatedRoute,Router } from '@angular/router';
  import { DomSanitizer } from '@angular/platform-browser';
  
  @Component({
    selector: 'app-fmtcelenmision',
    templateUrl: './fmtcelenmision.component.html',
    styleUrls: ['./fmtcelenmision.component.scss']
  })
  export class FmtcelenmisionComponent implements OnInit {
  
    cliente_id;
    id_celen=0;
    constructor(
      public authService: AuthService, 
      private route: ActivatedRoute,
      private _sanitizer: DomSanitizer,
      private router: Router) {
          this.cliente_id=localStorage.getItem('id_cliente');
          this.id_celen=Number(localStorage.getItem('id_celen'));     
    }
    ngOnInit() {
      this.Pgg4();
    }
  _celen;
  _detcelen=[];
  cliente;
  
  img_g5="";
    async Pgg4() {    
      var empresa="";
      var contador=0;    
      let postDatac={
        id_cliente:this.cliente_id,
      };      
      await this.authService.service("/api/get_clienteid",postDatac)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                          
              this.cliente=res;             
          },
          error => {           
          });   
  
          let postData={
            id:this.id_celen,     
           };
           console.log(postData);
           await this.authService.service("/api/get_celen_id",postData)
             .then(
               data => {           
                 var dat = JSON.stringify(data);
                 var res = JSON.parse(dat); 
                 this._celen=res; 
                 console.log(this._celen);          
               },
               error => {
                   var de= JSON.stringify(error);
                   var di = JSON.parse(de)
             });
  
      const pdf = new PdfMakeWrapper();    
      var img="";
      
      await this.authService.im_b64("/api/img_celenmision_b64",{id:localStorage.getItem("id_cliente")})  
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);  
          img=res.img;   
        });
        pdf.background(  {image: img,  width: 612,height:400    });
        pdf.pageSize( {width: 612,height: 400});
        pdf.pageOrientation("landscape");
        pdf.pageMargins([35, 220, 35, 60]);        
        pdf.add(new Table([
          [   
            {text:""},
            {text:this._celen[0].mision,color: '#000'},                
            {text:""},
            {text:this._celen[0].vision,color: '#000'},
            {text:""},
            {text:this._celen[0].objetivos,color: '#000'},
                
          ]
        ]).layout("noBorders").widths([ 50,115, 20,117,17,117]).fontSize(7).bold().alignment('justify').end);      
        pdf.create().open();              
        setTimeout(() => {
          window.close();
        },3000);
        
    }
    
 
  }
  
  
  